/* Responsibility: Draws the flight results when data is updated from the server. */
import preconditions from '../../lib/preconditions.js';
import imagePath from '../../lib/imagePath.js';
import dom from '../../lib/dom.js';

const checkPreconditions = preconditions('viewRenderer', {
    root: 'element',
    template: 'function',
    eventHub: 'eventHub',
});

export default function viewRenderer(params) {
    checkPreconditions(params);

    const render = (data) => {
        if (typeof params.dataPreparer === 'function') {
            params.dataPreparer(data, params.root);
        }
        if (typeof params.inconveniencesPreparer === 'function') {
            params.inconveniencesPreparer(data);
        }
        if (!params.disable) {
            params.root.innerHTML = params.template(Object.assign({}, data, imagePath));
        }
        if (dom.hasClass('hidden', params.root)) {
            dom.removeClass('hidden', params.root);
        }
        params.eventHub.publish('result-rendered');
    };

    params.eventHub.subscribe('changed-results', render);
}
